<div class="row" *ngFor="let item of agentList; let i = index">
  <!-- ROW LINEA -->
  <div class="row-line" [ngClass]="{ disabled: item.state != 'Activo' }">
    <p [ngStyle]="{ width: tableHeader[0].percentageWidth + '%' }" class="name">
      <b
        class="statusRMX"
        [ngClass]="{
          inactive: item.statusRMX == 'Inactivo',
          'null-status': !item.statusRMX
        }"
        [matTooltip]="(item.statusRMX ? item.statusRMX : 'Sin estado') + ' RMX'"
      ></b>
      <span> {{ item.name }} {{ item.lastname }}</span>
      <qr-icon
        *ngIf="item.state != 'Activo'"
        name="info"
        color="error-700"
        matTooltip="Agente inactivo"
      ></qr-icon>
    </p>
    <p
      [ngStyle]="{ width: tableHeader[1].percentageWidth + '%' }"
      class="type-agent"
    >
      {{ printAgentType(item.agentType).toLowerCase() }}
    </p>
    <p
      [ngStyle]="{ width: tableHeader[2].percentageWidth + '%' }"
      class="phone"
    >
      <a
        [href]="'https://wa.me/' + formatWhatsapp(item.cellphone)"
        target="_blank"
      >
        {{ item.cellphone }}
      </a>
    </p>
    <p
      [ngStyle]="{ width: tableHeader[3].percentageWidth + '%' }"
      class="email"
    >
      <a
        [href]="'mailto:' + (item.workEmail ? item.workEmail : item.email)"
        [matTooltip]="item.workEmail ? item.workEmail : item.email"
        target="_blank"
      >
        {{ item.workEmail ? item.workEmail : item.email }}
      </a>
    </p>
    <p
      [ngStyle]="{ width: tableHeader[4].percentageWidth + '%' }"
      class="closing"
    >
      {{
        userCurrency == "USD"
          ? "U$S " + formatNumber(item.billingUsd)
          : "$ " + formatNumber(item.billingArs)
      }}
    </p>
    <p
      [ngStyle]="{ width: tableHeader[5].percentageWidth + '%' }"
      class="antiquity"
    >
      {{
        this.typeAntiquity == ANTIQUITY_RMX
          ? print(item.antiquityRMX)
          : print(item.antiquityQR)
      }}
    </p>
    <div
      [ngStyle]="{ width: tableHeader[6].percentageWidth + '%' }"
      class="action"
    >
      <qr-button
        class="edit"
        [config]="buttonEdit"
        (click)="onModify(item.id)"
        matTooltip="Modificar"
      ></qr-button>
      <qr-button
        class="expand"
        [ngClass]="{ open: this.itemExpand == i }"
        [config]="buttonExpand"
        (click)="onExpandItem(i)"
        matTooltip="Expandir"
      ></qr-button>
    </div>
  </div>

  <!-- ROW EXPANDIDA -->
  <div class="row-expand" [ngClass]="{ open: this.itemExpand == i }">
    <ng-container *ngIf="this.agentDetail && this.itemExpand == i">
      <!-- PRIMERA COLUMNA -->
      <div class="column-box profile">
        <div class="box">
          <ng-container *ngIf="!isLoadingAgentDetail">
            <section>
              <div class="profile-photo">
                <qr-avatar
                  [size]="80"
                  [src]="
                    this.agentDetail && this.agentDetail.photo
                      ? this.agentDetail.photo
                      : ''
                  "
                ></qr-avatar>
                <div
                  class="status"
                  [ngClass]="{
                    inactive: agentDetail.statusRMX == 'Inactivo',
                    'null-status': agentDetail.statusRMX == null
                  }"
                ></div>
              </div>
              <div class="agent-info">
                <p class="name">
                  {{ print(agentDetail.name) }}
                  {{ print(agentDetail.lastName) }}
                </p>
                <p class="type">
                  Agente
                  {{ printAgentType() }} -
                  {{ formatAgentLevel(print(agentDetail.agentLevelType)) }}
                </p>
                <div
                  class="office"
                  [class.office--clickable]="agentDetail.teamName"
                  (click)="agentDetail.teamName && onGoToTeam()"
                >
                  <p>
                    {{
                      agentDetail.teamName
                        ? "Team: " + print(agentDetail.teamName)
                        : ""
                    }}
                  </p>
                  <qr-icon
                    *ngIf="agentDetail.teamName"
                    [name]="ICON_ARROW_RIGHT_UP"
                    color="primary-500"
                    matTooltip="Ver team"
                    matTooltipPosition="above"
                    matTooltipClass="team-link-tooltip"
                  ></qr-icon>
                </div>
              </div>
            </section>
            <section>
              <div class="box-line">
                <qr-icon name="location" color="grey-700"></qr-icon>
                <span class="address">
                  {{
                    print(agentDetail.street) +
                      " " +
                      print(agentDetail.streetNumber) +
                      ", " +
                      print(agentDetail.city)
                  }}
                  <!-- ", " +
                      agentDetail.state +
                      ", " +
                      agentDetail.country  -->
                </span>
              </div>
              <div class="box-line">
                <qr-icon name="whatsapp" color="grey-700"></qr-icon>
                <a
                  [href]="
                    'https://wa.me/' + formatWhatsapp(agentDetail.cellphone)
                  "
                  target="_blank"
                  >{{ print(agentDetail.cellphone) }}</a
                >
              </div>
              <div class="box-line">
                <qr-icon name="email" color="grey-700"></qr-icon>
                <a [href]="'mailto:' + agentDetail.email" target="_blank">{{
                  print(agentDetail.email)
                }}</a>
              </div>
              <div class="box-line">
                <qr-icon name="credential" color="grey-700"></qr-icon>
                <a [href]="'mailto:' + agentDetail.workEmail" target="_blank">{{
                  print(agentDetail.workEmail)
                }}</a>
              </div>
              <div class="box-line">
                <qr-icon name="cake" color="grey-700"></qr-icon>
                {{ agentDetail.birthday | date : "dd/MM/yyyy" }}
              </div>
            </section>
          </ng-container>
          <div class="loader" *ngIf="isLoadingAgentDetail">
            <div class="loader-line">
              <qr-skeleton-loader></qr-skeleton-loader>
            </div>
            <div class="loader-line">
              <qr-skeleton-loader></qr-skeleton-loader>
            </div>
            <div class="loader-line">
              <qr-skeleton-loader></qr-skeleton-loader>
            </div>
          </div>
        </div>
      </div>

      <!-- SEGUNDA COLUMNA -->
      <div class="column-box second">
        <div
          class="box top"
          [ngClass]="{
            'four-elements':
              agentDetail.downDateRMX ||
              agentDetail.rauRequest?.state == 'Pendiente'
          }"
        >
          <ng-container *ngIf="!isLoadingAgentDetail">
            <div class="line">
              <div class="key">Ingreso</div>
              <div class="value">
                {{ print(agentDetail.beginDate | date : "dd/MM/yyyy") }}
              </div>
            </div>
            <div class="line">
              <div class="key">Alta RE/MAX</div>
              <div class="value">
                {{
                  agentDetail.statusRMX == "Activo" ||
                  agentDetail.statusRMX == "Inactivo" ||
                  (agentDetail.rauRequest?.state == "Pendiente" &&
                    agentDetail.rauRequest?.type == "Baja")
                    ? print(agentDetail.estateDate | date : "dd/MM/yyyy")
                    : "-"
                }}
              </div>
            </div>
            <div class="line">
              <div class="key">ID Agente</div>
              <div class="value">{{ print(agentDetail.agentId) }}</div>
            </div>
            <!-- Estado de baja -->
            <div
              class="line"
              *ngIf="
                agentDetail.downDateRMX ||
                agentDetail.rauRequest?.state == 'Pendiente'
              "
            >
              <div class="key">
                {{
                  agentDetail.rauRequest ? agentDetail.rauRequest.type : "Baja"
                }}
                RE/MAX
              </div>
              <div class="value" *ngIf="agentDetail.downDateRMX">
                {{ agentDetail.downDateRMX | date : "dd/MM/yyyy" }}
              </div>
              <div class="value" *ngIf="!agentDetail.downDateRMX">
                {{ agentDetail.rauRequest?.state }}
              </div>
            </div>
          </ng-container>
          <div class="loader" *ngIf="isLoadingAgentDetail">
            <div class="loader-line">
              <qr-skeleton-loader></qr-skeleton-loader>
            </div>
            <div class="loader-line">
              <qr-skeleton-loader></qr-skeleton-loader>
            </div>
          </div>
        </div>
        <div class="box bottom">
          <ng-container *ngIf="!isLoadingAgentDetail">
            <p>Cierres</p>
            <h2>
              {{
                userCurrency == "USD"
                  ? "U$S " + formatNumber(agentDetail.billedUSD)
                  : "$ " + formatNumber(agentDetail.billedARS)
              }}
            </h2>
            <qr-button *ngIf="false" [config]="buttonClosures"></qr-button>
          </ng-container>
          <div class="loader" *ngIf="isLoadingAgentDetail">
            <div class="loader-line">
              <qr-skeleton-loader></qr-skeleton-loader>
            </div>
            <div class="loader-line">
              <qr-skeleton-loader></qr-skeleton-loader>
            </div>
          </div>
        </div>
      </div>

      <!-- TERCERA COLUMNA -->
      <div class="column-box third">
        <div class="box verification">
          <ng-container *ngIf="!isLoadingAgentDetail">
            <p>Verificación</p>
            <ul
              *ngIf="
                agentDetail &&
                  agentDetail.agentVerifications &&
                  agentDetail.agentVerifications.length > 0;
                else noVerifications
              "
            >
              <li *ngFor="let item of agentDetail?.agentVerifications">
                <qr-icon name="check" color="success-500"></qr-icon>
                <span>{{ item.name }}</span>
              </li>
            </ul>
            <ng-template #noVerifications>
              <div class="empty-verifications">
                Ninguna verificación
              </div></ng-template
            >
          </ng-container>
          <div class="loader" *ngIf="isLoadingAgentDetail">
            <div class="loader-line">
              <qr-skeleton-loader></qr-skeleton-loader>
            </div>
            <div class="loader-line">
              <qr-skeleton-loader></qr-skeleton-loader>
            </div>
          </div>
        </div>
        <div class="box antiquity">
          <ng-container *ngIf="!isLoadingAgentDetail">
            <div class="row-antiquity">
              Antigüedad RMX <span>{{ agentDetail.antiquityRMX }}</span>
            </div>
            <div class="row-antiquity">
              Antigüedad QR <span>{{ agentDetail.antiquityBegin }}</span>
            </div>
          </ng-container>
          <div class="loader" *ngIf="isLoadingAgentDetail">
            <div class="loader-line">
              <qr-skeleton-loader></qr-skeleton-loader>
            </div>
            <div class="loader-line">
              <qr-skeleton-loader></qr-skeleton-loader>
            </div>
          </div>
        </div>
        <div class="buttons" *ngIf="!isLoadingAgentDetail">
          <qr-button
            [config]="buttonModif"
            (click)="onModify(item.id)"
          ></qr-button>
          <qr-button
            [config]="buttonRemoveAgent"
            (click)="buttonRemoveAgentClick()"
            [isDisabled]="
              agentDetail.statusRMX == null ||
              agentDetail.statusRMX == 'Inactivo' ||
              (agentDetail.rauRequest?.type == 'Baja' &&
                agentDetail.rauRequest?.state == 'Pendiente')
            "
          ></qr-button>
        </div>
      </div>
    </ng-container>
  </div>
</div>
<div class="empty" *ngIf="agentList.length == 0">
  <h2 class="display-02-semi-bold">Ningún resultado</h2>
</div>
